<template>
  <div>
    <h1 class="common__main-title">Student Edit</h1>
    <div class="common__sub-title">
      <span>Details</span>
    </div>
    <div class="content-wrapper">
      <div class="main-content">
        <ConfirmForm :student="$route.params.editingStudent" />
      </div>
      <div class="d-flex justify-content-between">
        <b-button
          pill
          variant="secondary"
          :to="{
            name:'EditStudent',
            params: {
              id: $route.params.id,
              editingStudent: $route.params.editingStudent,
            }
          }"
        >
          Back
        </b-button>
        <b-button
          pill
          variant="primary"
          @click="updateStudent"
        >
          Edit
        </b-button>
      </div>
    </div>
    <SuccessModal @ok="success" ref="sucessModal" />
    <ErrorModal @ok="error" ref="errorModal" />
    <Loading :isLoading="isLoading"/>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import ConfirmForm from '@/components/parts/students/StudentConfirmForm.vue';
import SuccessModal from '@/components/parts/modal/Success.vue';
import ErrorModal from '@/components/parts/modal/Error.vue';
import Loading from '@/components/parts/modal/Loading.vue';

export default Vue.extend({
  data() {
    return {
      isLoading: false,
    };
  },

  components: {
    ConfirmForm,
    SuccessModal,
    ErrorModal,
    Loading,
  },

  created() {
    if (!this.$route.params.editingStudent) {
      this.$router.push({
        name: 'StudentDetail',
        params: { id: this.$route.params.id },
      });
    }
  },

  methods: {
    updateStudent() {
      if (this.isLoading) {
        return
      }
      this.isLoading = true;

      this.$store.dispatch('editStudent', {
        id: this.$route.params.id,
        student: this.$route.params.editingStudent,
      })
        .then(() => {
          (this.$refs.sucessModal as SuccessModal).open();
        })
        .catch((error) => {
          (this.$refs.errorModal as ErrorModal).open(error.response.data.message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    /* 成功モーダルのOKボタン押下時の処理 */
    success() {
      this.$router.push({
        name: 'StudentDetail',
        params: { id: this.$route.params.id },
      });
    },

    error() {
      this.$router.push({
        name: 'EditStudent',
        params: {
          id: this.$route.params.id,
          editingStudent: this.$route.params.editingStudent,
        },
      });
    },
  },
})
</script>

<style scoped>

.tutor-name {
  background: #DDEAF6;
  padding:50px 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
}

.content-wrapper {
  background: #D8D8D8;
  padding: 20px 70px;
}

.main-content {
  background: #fff;
  padding: 20px;
  border-radius: 20px;
  margin-bottom:20px;
}
</style>
